type ObjectWithAddedAt = {
  addedAt: Date;
};

const sortByAddedAt = (a: ObjectWithAddedAt, b: ObjectWithAddedAt): number => {
  return a.addedAt.getTime() - b.addedAt.getTime();
};

export default sortByAddedAt;
